import { Link } from "react-router";
import { ScrollOpening, HorizontalSequence, Panorama } from "../components/portfolio/ScrollPortfolio";
import { useScrollScene } from "../components/portfolio/use-scroll-scene";
import { HomeSky } from "../components/portfolio/HomeSky";
import { getAllImages } from "../lib/portfolios";
import site from "../content/site.json";

export function meta() {
  return [
    { title: "Captures by Mari — Photography in Kern County" },
    { name: "description", content: "Photography by Mari in Kern County, California. Inquire about weddings, portraits, family sessions, school photography, and events." },
  ];
}

export default function IndexRoute() {
  const atmosphere = useScrollScene((progress, layer) => {
    layer.style.setProperty("--wash-progress", (1 - (1 - progress) ** 2).toFixed(4));
  });
  const images = getAllImages();
  const opening = ["goalkeeper_sunset", "hurdles", "jersey_back", "sprint_blocks", "distance"].map((name) => images.find((image) => image.src.includes(name))!);
  const selected = ["soccer_action", "soccer_portrait", "warmup"].map((name) => images.find((image) => image.src.includes(name))!);
  return (
    <main ref={atmosphere.root} className="home-page">
      <div ref={atmosphere.stage} className="home-atmosphere" aria-hidden="true"><HomeSky /></div>
      <ScrollOpening images={opening} />
      <section className="home-introduction">
        <h2>Hi, I'm<br /> Mari.</h2>
        <div>
          <p>I photograph people, celebrations, and everything happening around them.</p>
          <nav aria-label="About and inquiries"><Link to="/about">About me ↗</Link><a href={site.instagram} target="_blank" rel="noopener noreferrer">Get in touch ↗</a></nav>
        </div>
      </section>
      <HorizontalSequence images={selected} />
      <Panorama images={images} />
    </main>
  );
}
